import React, { useEffect } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
export function App() {
  useEffect(() => {
    const pixelWindow = window as PixelWindow;
    try {
      if (!pixelWindow.fbq) {
        const fbq = ((...args: unknown[]) => {
          if (fbq.callMethod) {
            fbq.callMethod(...args);
          } else {
            fbq.queue?.push(args);
          }
        }) as PixelFunction;
        pixelWindow.fbq = fbq;
        if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript?.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          document.head.appendChild(script);
        }
      }
      pixelWindow.fbq?.('init', '1291989329683929');
      pixelWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="356tf9929ob6">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1291989329683929&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="34x4lozr5n72" />
      </noscript>
      <div className="min-h-screen overflow-x-hidden bg-brand-cloud text-brand-slate selection:bg-brand-sage" data-id="element-2" data-mp="d2bj3j2481wq">
        <UrgencyBanner data-id="element-3" data-mp="3gle90gn0mze4" />
        <main data-id="element-4" data-mp="3gkla21uate6j">
          <Hero data-id="element-5" data-mp="3gmft1am0ew7z" />
          <PainSection data-id="element-6" data-mp="3glwabrojc3sw" />
          <SystemSection data-id="element-7" data-mp="3gj1s86szuv2n" />
          <BonusSection data-id="element-8" data-mp="3bmtjbb5e3y3x" />
          <PricingCard data-id="element-9" data-mp="3bncso3gz5e6c" />
          <Guarantee data-id="element-10" data-mp="3bo4kr4bd4trv" />
          <Testimonials data-id="element-11" data-mp="3bkguce17snhd" />
          <FAQ data-id="element-12" data-mp="3qbppf2nvz11w" />
          <FinalCTA data-id="element-13" data-mp="3qc966g1svjec" />
        </main>
        <Footer data-id="element-14" data-mp="3qdaj6q2dmfyp" />
      </div>
    </>;
}